var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconReportes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 5.59733H7.58333V2.09733H2.91667V12.5973H11.0833V5.59733ZM10.2579 4.43066L8.75 2.92275V4.43066H10.2579ZM8.40875 0.930664L12.25 4.77191V13.764H1.75V0.930664H8.40875Z",
    fill: "#7B7B7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08398 7.92936V6.7627H6.41732V7.92936H4.08398ZM4.08398 10.2627V9.09603H9.91732V10.2627H4.08398Z",
    fill: "#7B7B7B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReportes);
export default __webpack_public_path__ + "static/media/icon-reportes.609f7ab5.svg";
export { ForwardRef as ReactComponent };